import mysql from "mysql";

export function dbConnect(): string {
    const dbUrl: string = process.env.NODE_ENV === "production" ? "prod" : "test";
    const dbUser: string = "user";
    const dbPassword: string = "pass";

    return dbUrl + " " + dbUser + " " + dbPassword;
}
